import {WorkshopSection} from '../types/WorkshopOverviewTileConfig';
import {WorkshopSectionAppearance} from '../types/WorkshopSectionAppearance';

export const WORKSHOP_SECTION_APPEARANCE: Record<WorkshopSection, WorkshopSectionAppearance> = {
  critical: {
    titleKey: 'page.myProfile.dashboard.labels.critical',
    backgroundColor: 'palettes.red.10.100',
    accentColor: 'severity.danger',
    iconBackgroundColor: 'palettes.red.20.100',
    tileBackgroundColor: 'palettes.red.10.100',
    tileBorderColor: 'palettes.red.30.100',
    tileHoverBackgroundColor: 'palettes.red.20.100',
    tileHoverBorderColor: 'palettes.red.50.100',
    skeletonColor: 'palettes.red.20.100',
    badgeColorScheme: 'red',
  },
  warning: {
    titleKey: 'page.myProfile.dashboard.labels.warning',
    backgroundColor: 'palettes.orange.10.100',
    accentColor: 'severity.warning',
    iconBackgroundColor: 'palettes.orange.20.100',
    tileBackgroundColor: 'palettes.orange.10.100',
    tileBorderColor: 'palettes.orange.30.100',
    tileHoverBackgroundColor: 'palettes.orange.20.100',
    tileHoverBorderColor: 'palettes.orange.50.100',
    skeletonColor: 'palettes.orange.20.100',
    badgeColorScheme: 'orange',
  },
  today: {
    titleKey: 'page.myProfile.dashboard.labels.today',
    backgroundColor: 'palettes.blue.10.100',
    accentColor: 'severity.informational',
    iconBackgroundColor: 'palettes.blue.20.100',
    tileBackgroundColor: 'palettes.blue.10.100',
    tileBorderColor: 'palettes.blue.30.100',
    tileHoverBackgroundColor: 'palettes.blue.20.100',
    tileHoverBorderColor: 'palettes.blue.50.100',
    skeletonColor: 'palettes.blue.20.100',
    badgeColorScheme: 'blue',
  },
};
